import { createApiClient } from "@homesite/queries";
import { env } from "./env";

export const apiClient = createApiClient({
	baseUrl: env.VITE_API_URL,
});
